import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { filters, Rectangle } from "pixi.js";
import { AnimationContents } from "../../../AnimationContents";
import { ButtonController } from "../../Common/ButtonController";
import { LocalizationContents } from "../../LocalizationContents";
import { GameLogic } from "../../Logic/GameLogic";
import { GameModel } from "../../Models/GameModel";
import { setCookie } from "../../Utils/Helpers";
import { resizeScreen } from "../../Utils/Resize";

export class ftueController extends AnimationBaseController {
    $model: GameModel;
    private stage = 0;

    constructor(
        @Inject private options: { close: () => void },
        @Inject private gameLogic: GameLogic,
    ) {
        super("ftueController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.FTUE_JSON,
            libraryName: "tutor",
            childControllers: {
                left: {
                    instanceName: "slider_tutor.left",
                    controller: ButtonController,
                    options: {
                        onClick: () => {
                            if (this.stage != 0)
                                this.stage -= 2;
                            else
                                this.stage = -1;
                            if (this.stage < -1) this.stage = 0;
                            if (this.stage >= 0)
                                this.changeSlide();
                        }
                    }
                },
                right: {
                    instanceName: "slider_tutor.right",
                    controller: ButtonController,
                    options: {
                        onClick: () => {
                        }
                    }
                },
                exit: {
                    instanceName: "btn_exit",
                    controller: ButtonController,
                    options: {
                        onClick: () => {
                            this.options.close();
                        }
                    }
                }

            },
            onPointerUp: () => {
                try {
                    this.stage++;
                    if (this.stage > 3) this.stage = 3;
                    this.changeSlide();
                }
                catch (e) {
                    alert("on pointer up\n" + e);
                }
            }

        }
    }

    protected onInitialize(): void {
        
        //bad code here
        // try {
            this.$model.pause = true;
            this.setStyle();
            this.changeSlide(this.stage);
            this.getDisplayObjectByQuery("slider_tutor.right")[0].hitArea = new Rectangle(-100, -100, 200, 200);
            this.getDisplayObjectByQuery("slider_tutor.left")[0].hitArea = new Rectangle(-100, -100, 200, 200);
            this.getDisplayObjectByQuery("btn_exit")[0].hitArea = new Rectangle(-100, -100, 200, 200);
            setCookie("ftue", "ftue", 99999);
        // }
        // catch (e) {
        //     alert("ololo\n" + e);
        // }

    }

    setStyle() {
        this.setTextStyleByQuery("title", { valign: "middle" }, {
        });
        this.setTextStyleByQuery("text", { valign: "middle" }, {
            b: {
                fill: "#00DFF9"
            }
        });
        this.setTextVerticalAlignByQuery("title", "middle");
        this.setTextVerticalAlignByQuery("text", "middle");
    }

    localise(stage) {
        this.setTextByQuery("title", LocalizationContents.getText("title_ftue_" + (stage + 1)));
        this.setTextByQuery("text", LocalizationContents.getText("text_ftue_" + (stage + 1)));
    }

    changeSlide(slide: number = this.stage) {
        this.gotoAndStop(slide);
        for (let i = 0; i < 4; i++)
            this.gotoAndStopByQuery("slider_tutor.slide" + i, 0);
        this.gotoAndStopByQuery("slider_tutor.slide" + slide, 1);
        this.localise(slide);
    }

    protected onResize(width: number, height: number, scale: number): void {
        resizeScreen(width, height, scale, this);
    }
}